import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPsychologicalListByPatientid, addQuestionnaireAnswer, addQuestionnaireAnswerPsychological } from '@/api/module/index';
import { Dialog, Toast } from "vant";
import { GetAge } from '@/assets/utils/utils';
export default {
  name: "index",
  data: function data() {
    return {
      user: undefined,
      name: '',
      radio: '',
      message: new Array(),
      questions: [],
      //调查问卷列表
      checkboxResult: [],
      checkRadioMap: new Map(),
      //选择的单选题目答案
      checkBoxMap: new Map(),
      //选择的多选题答案
      answers: [],
      typeid: "",
      serialno: "",
      questionList: [],
      // 问卷id
      questionsid: '',
      submitBubbles: false,
      // 问卷名称
      typeName: '',
      // 问卷数量
      typeNumber: 0,
      // 问卷使用数量
      typeUseNumber: 0,
      // 答题后提示恭喜完成
      congratulation: false
    };
  },
  created: function created() {
    this.getList();
    this.name = window.g.VUE_APP_HOSPITALNAME;
  },
  methods: {
    getList: function getList() {
      var _this = this;

      this.user = JSON.parse(localStorage.getItem("loginuser"));

      if (!this.user) {
        this.user = JSON.parse(localStorage.getItem("GuideUser"));
      }

      if (this.user.name == undefined) {
        Dialog.alert({
          title: '提示',
          message: '请您完善个人资料！'
        }).then(function () {
          _this.$router.push({
            name: 'userinfo'
          });
        });
        return;
      }

      var params = {
        patientid: this.user.patientid
      };
      getPsychologicalListByPatientid(params).then(function (res) {
        if (res.code == 200) {
          _this.questionList = res.data;

          if (_this.questionList.length > 0) {
            _this.typeNumber = _this.questionList.length;

            _this.init();

            _this.submitBubbles = true;
          }
        }
      });
    },
    // 问卷初始化
    init: function init() {
      this.questions = this.questionList[0].typeDate;
      this.typeid = this.questionList[0].typeid;
      this.questionsid = this.questionList[0].questionsid;
      this.typeName = this.questionList[0].typeName;
      this.typeUseNumber = this.typeUseNumber + 1; // 去掉已答题问卷

      this.questionList.splice(0, 1);
      this.checkRadioMap = new Map();
      this.checkBoxMap = new Map();
    },
    //单选框点击
    radioChange: function radioChange(questionid, optionsid) {
      this.checkRadioMap.set(questionid, optionsid);
    },
    //多选框点击
    checkboxChange: function checkboxChange(questionid, optionsid) {
      if (this.checkBoxMap.has(questionid)) {
        //多选题，如果有选择过答案
        var str = this.checkBoxMap.get(questionid);

        if (str.includes(optionsid)) {
          //如果已经选择了，则取消
          var arr = new Array();
          arr = str.split("|");
          arr = arr.filter(function (item) {
            return item !== optionsid;
          });
          this.checkBoxMap.set(questionid, arr.join("|"));
        } else {
          //如果没有选择，则添加
          if (this.checkBoxMap.get(questionid) == "") {
            this.checkBoxMap.set(questionid, optionsid);
          } else {
            this.checkBoxMap.set(questionid, str + "|" + optionsid);
          }
        }
      } else {
        this.checkBoxMap.set(questionid, optionsid);
      }
    },
    //满意度调查问卷提交
    submit: function submit() {
      var _this2 = this;

      var strArr = new Array(); //用来存放文本类型的答案

      var arr = document.getElementsByName("textarea");
      arr.forEach(function (item) {
        if (item.value != '') {
          strArr.push(item.value);
        } else {
          strArr.push("");
        }
      });

      if (this.checkRadioMap.size == 0 && this.checkBoxMap.size == 0 && strArr.length == 0 || this.questions.length != this.checkRadioMap.size + this.checkBoxMap.size + strArr.length) {
        Dialog.confirm({
          title: '提示',
          message: '您还没有全部答完，是否继续填写？点击确认继续答卷，点击取消返回个人中心'
        }).then(function () {// on confirm
        }).catch(function () {
          _this2.$router.push({
            name: 'userinfo'
          });
        });
        return;
      } else {
        var _this$user$birthdate;

        var param = {
          name: this.user.name,
          phone: this.user.phone,
          cardid: this.user.cardid,
          age: GetAge(this.user.cardid),
          patientID: this.user.patientid,
          physicalNo: this.user.physicalno,
          serialNo: this.serialno,
          sexID: this.user.sexid,
          birthDate: ((_this$user$birthdate = this.user.birthdate) === null || _this$user$birthdate === void 0 ? void 0 : _this$user$birthdate.substring(0, 10)) || '',
          marital: this.user.marital,
          typeID: this.typeid,
          id: this.questionsid
        }; //问题的字符串集合
        //答案的字符串集合

        var questionnaireAnswerList = new Array();
        this.checkRadioMap.forEach(function (value, key) {
          if (value != '') {
            // 筛选出分数
            var score = _this2.questions.filter(function (item) {
              return item.questionid == key;
            })[0].questionsOptions.filter(function (item) {
              return item.optionsid == value;
            })[0].score;

            console.log(score);
            var answer = {
              questionid: key,
              result: value,
              score: score
            };
            questionnaireAnswerList.push(answer);
          }
        });
        this.checkBoxMap.forEach(function (value, key) {
          if (value != '') {
            var answer = {
              questionid: key,
              result: value
            };
            questionnaireAnswerList.push(answer);
          }
        });
        param.questionnaireAnswerList = questionnaireAnswerList; //文本填写答案

        param.answerstr = strArr.join(",");
        param.questionidstr = this.questions.filter(function (item) {
          return item.optiontype == '3';
        }).map(function (item) {
          return item.questionid;
        }).join(",");
        addQuestionnaireAnswerPsychological(param).then(function (res) {
          if (_this2.questionList == 0) {
            _this2.submitBubbles = false;
            _this2.congratulation = res.data;
            _this2.questions = [];
            return;
          }

          if (res.code == 200) {
            if (_this2.typeNumber > _this2.typeUseNumber) {
              var number = _this2.questionList.length;
              Dialog.confirm({
                title: '提交成功',
                message: '剩余' + number + '份问卷，请问是否继续答题',
                confirmButtonText: '下一份',
                cancelButtonText: '返回主页'
              }).then(function () {
                _this2.init();
              }).catch(function () {
                _this2.$router.push({
                  name: 'home'
                });
              });
            }
          }
        });
      }
    }
  }
};